import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ServicesComponent } from './pages/services/services.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ContactComponent } from './pages/contact/contact.component';
import { INVOICE_ROUTES } from './invoice/invoice-routing.module';
import { AUTH_ROUTES } from './auth/auth-routing.module';
import { DASHBOARD_ROUTES } from './dashboard/dashboard-routing.module';
import { authGuard } from './auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent() {
      return import('./layout/public-layout/public-layout.component').then(m => m.PublicLayoutComponent);
    },
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'about',
        component: AboutComponent
      },
      {
        path: 'services',
        component: ServicesComponent
      },
      {
        path: 'pricing',
        component: PricingComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      {
        path: 'invoice',
        children: INVOICE_ROUTES
      },
      {
        path: 'auth',
        children: AUTH_ROUTES
      }      
    ]
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent() {
      return import('./layout/dashboard-layout/dashboard-layout.component').then(m => m.DashboardLayoutComponent);
    },
    children: DASHBOARD_ROUTES
  },
  {
    path: '**',
    redirectTo: ''
  }
];
